function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bom0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M112.323 272.422C112.323 272.422 -13.112 385.09 17.235 457.938C47.582 530.786 124.081 541.719 124.081 541.719L136.254 571.838L162.954 505.279L112.323 434.871C112.323 434.871 162.133 416.661 167.389 375.379C172.645 334.097 171.822 243.279 171.822 243.279",
  fill: "#E4AB4E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.389 375.379C163.673 404.552 137.708 422.203 122.789 430.044C116.344 416.582 115.041 398.494 115.041 378.014C115.041 336.883 128.453 303.091 148.36 303.091C156.953 303.091 164.787 309.264 170.974 319.561C170.332 340.227 169.237 360.864 167.389 375.379Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.92 245.11C133.92 245.11 117.584 511.813 163.731 638.086L154.093 652.25H236.184C236.184 652.25 245.149 313.016 245.149 239.79L133.92 245.11Z",
  fill: "#FFC85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.405 38.738V73.396L202.341 83.951V25.451L159.405 14.907V38.738Z",
  fill: "#FFE1B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.282 50.725C184.915 50.725 185.428 50.2119 185.428 49.579C185.428 48.9461 184.915 48.433 184.282 48.433C183.649 48.433 183.136 48.9461 183.136 49.579C183.136 50.2119 183.649 50.725 184.282 50.725Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.652 50.725C167.285 50.725 167.798 50.2119 167.798 49.579C167.798 48.9461 167.285 48.433 166.652 48.433C166.019 48.433 165.506 48.9461 165.506 49.579C165.506 50.2119 166.019 50.725 166.652 50.725Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.822 56.425V38.738H162.957",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.444 38.738H177.579",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.136 47.796V53.918C201.727 53.918 203.253 53.2858 204.379 52.1606C205.504 51.0354 206.136 49.5093 206.136 47.918V47.374C205.779 43.671 200.136 44.058 200.136 47.796Z",
  fill: "#FFE1B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.136 53.919C201.727 53.919 203.253 53.2869 204.379 52.1616C205.504 51.0364 206.136 49.5103 206.136 47.919",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.696 63.227C177.306 63.227 178.851 62.5872 179.99 61.4485C181.128 60.3098 181.768 58.7654 181.768 57.155",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.028 73.396L202.964 83.951",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.822 56.439L175.696 57.391",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.847 44.202C198.847 44.202 192.102 37.994 190.619 30.847C190.619 30.847 179.419 33.711 173.219 32.465V28.692C173.219 28.692 165.664 31.657 158.11 30.31V26.264",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.102 22.891H153.383C153.383 22.891 162.553 1.84599 197.901 11.155L195.338 6.29999C195.338 6.29999 205.864 8.05399 206.265 17.363C206.265 17.363 208.291 16.146 211.793 19.511L208.828 21.265C208.828 21.265 215.717 45.547 202.963 58.773",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245.148 146.013V239.776L112.323 272.421V167.996C112.324 150.006 118.356 132.535 129.456 118.377C140.556 104.219 156.082 94.1907 173.552 89.896V89.896C182.063 87.8041 190.939 87.6748 199.508 89.5181C208.077 91.3614 216.114 95.1289 223.012 100.536C229.911 105.943 235.489 112.847 239.326 120.727C243.163 128.608 245.158 137.257 245.16 146.022L245.148 146.013Z",
  fill: "#AC7FE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.846 267.381C132.846 267.381 117.586 511.792 163.738 638.065",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.762 179.124L238.912 219.446C238.912 219.446 231.271 215.909 223.366 212.285L200.136 176.94L201.762 179.124Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.379 98.179C220.379 98.179 310.153 153.818 302.047 226.056C296.77 273.08 226.916 310.369 147.418 203.929C147.418 203.929 129.366 197.663 138.539 183.421C138.539 183.421 127.998 175.866 131.113 173.167C134.228 170.468 238.913 219.039 238.913 219.039L200.138 176.948",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.654 120.772C127.654 120.772 91.736 154.313 82.541 193.711C82.541 193.711 75.932 128.942 67.833 120.772C59.734 112.602 55.96 120.772 55.96 120.772C55.96 120.772 27.898 108.19 27.898 117.141C27.898 126.092 46.237 135.809 46.237 135.809C46.237 135.809 9.47401 311.709 112.324 265.877",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.931 54.118C23.9305 49.7434 24.996 45.4346 27.0353 41.5645C29.0745 37.6943 32.0261 34.3793 35.6345 31.9063C39.243 29.4333 43.3997 27.8768 47.745 27.3715C52.0903 26.8662 56.4933 27.4273 60.5729 29.0063C64.6526 30.5852 68.2861 33.1345 71.159 36.4334C74.0319 39.7324 76.0577 43.6817 77.0611 47.9396C78.0646 52.1975 78.0153 56.6358 76.9178 60.8705C75.8202 65.1051 73.7073 69.0085 70.762 72.243C66.5444 76.7941 64.1815 82.7582 64.138 88.963V88.963C64.138 89.1948 64.0459 89.4171 63.882 89.581C63.7181 89.7449 63.4958 89.837 63.264 89.837H38.481C38.2492 89.837 38.0269 89.7449 37.863 89.581C37.6991 89.4171 37.607 89.1948 37.607 88.963V88.963C37.635 82.872 35.3435 76.9987 31.198 72.536C26.5149 67.5484 23.9152 60.9595 23.931 54.118V54.118Z",
  fill: "#FFC85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.999 18.108V0.75",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.729 24.846L81.933 10.804",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.54 42.483L101.053 37.112",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.54 64.28L101.053 69.643",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.458 64.28L0.945007 69.643",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.458 42.483L0.945007 37.112",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.268 24.846L20.064 10.804",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.785 95.515L38.933 93.245",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.48 101.201L41.239 99.368",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.013 105.49L44.704 104.323",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.703 84.366L59.503 58.294C59.5934 57.6756 59.8613 57.0967 60.2742 56.6275C60.6871 56.1583 61.2273 55.819 61.8292 55.6507C62.4311 55.4824 63.0689 55.4923 63.6652 55.6793C64.2616 55.8662 64.7909 56.2222 65.189 56.704L65.225 56.747C65.5727 57.1987 65.7701 57.7479 65.7896 58.3176C65.8091 58.8873 65.6497 59.4488 65.3337 59.9232C65.0177 60.3976 64.5611 60.7611 64.0279 60.9627C63.4947 61.1642 62.9118 61.1937 62.361 61.047",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.634 61.029C39.0832 61.1757 38.5003 61.1462 37.9671 60.9447C37.4339 60.7431 36.9773 60.3796 36.6613 59.9052C36.3453 59.4307 36.1859 58.8693 36.2054 58.2996C36.2249 57.7299 36.4223 57.1807 36.77 56.729L36.806 56.686C37.2041 56.2042 37.7334 55.8482 38.3298 55.6613C38.9262 55.4743 39.564 55.4644 40.1658 55.6327C40.7677 55.801 41.3079 56.1403 41.7208 56.6095C42.1337 57.0787 42.4016 57.6576 42.492 58.276L46.28 84.341",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.918 60.12L58.66 60.027C53.537 58.1179 47.8923 58.151 42.792 60.12V60.12",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.287 40.457C66.8815 37.2392 63.6499 34.7326 59.935 33.203",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.982 48.018C72.5434 46.4021 71.9238 44.8409 71.135 43.364",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bom0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 303.334,
  height: 652.25,
  fill: "white"
})));

var SvgBulbOMan = function SvgBulbOMan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 653,
    viewBox: "0 0 304 653",
    fill: "none",
    className: "hidden md:block absolute right-0 top-0 mt-40 mr-20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBulbOMan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BulbOMan.3b3bd144.svg";
export { ForwardRef as ReactComponent };